import api from './client';

export interface EquipmentType {
  id: number;
  name: string;
}

export const getEquipmentTypes = () =>
  api.get<EquipmentType[]>('/equipment-types').then(r => r.data);

export const createEquipmentType = (name: string) =>
  api.post<EquipmentType>('/equipment-types', { name }).then(r => r.data);

export const updateEquipmentType = (id: number, name: string) =>
  api.put<EquipmentType>(`/equipment-types/${id}`, { name }).then(r => r.data);

export const deleteEquipmentType = (id: number) =>
  api.delete(`/equipment-types/${id}`);
